var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00997 5.79149L0.47942 4.86077C0.0086662 4.57451 -0.140894 3.96083 0.145369 3.49007C0.431631 3.01932 1.04531 2.86976 1.51607 3.15602L14.5243 11.0662C14.9951 11.3525 15.1446 11.9662 14.8584 12.4369C14.5721 12.9077 13.9584 13.0573 13.4877 12.771L10.8998 11.1973C10.3232 11.5428 9.68541 11.7888 9.00354 11.9114V14H10.0035C10.5558 14 11.0035 14.4477 11.0035 15C11.0035 15.5523 10.5558 16 10.0035 16H8.00354H6.00354C5.45125 16 5.00354 15.5523 5.00354 15C5.00354 14.4477 5.45125 14 6.00354 14H7.00354V11.9114C4.19766 11.4069 2.1391 8.81371 2.00997 5.79149ZM4.29094 7.17853C4.89586 8.8696 6.3793 10 8.00354 10C8.26913 10 8.53095 9.96977 8.78579 9.91182L4.29094 7.17853ZM14.0035 5.4898C14.0035 6.701 13.6928 7.85317 13.1456 8.84224L11.4399 7.8035C11.7955 7.13624 12.0035 6.34947 12.0035 5.4898V5C12.0035 4.44771 12.4513 4 13.0035 4C13.5558 4 14.0035 4.44771 14.0035 5V5.4898ZM10.0035 6C10.0035 6.29282 9.94061 6.57095 9.82753 6.82159L6.00354 4.49282V2C6.00354 0.895431 6.89897 0 8.00354 0C9.10811 0 10.0035 0.895431 10.0035 2V6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMute);
export default __webpack_public_path__ + "static/media/avatar_mute.f7679c2e.svg";
export { ForwardRef as ReactComponent };